<template>
    <div class="guide-bg">
        <Slider
            class="guide-swiper"
            ref="guide"
            :slideDots="sliders"
            :showDots="showDots"
        >
            <p
                class="slide-p"
                v-for="(item, index) in sliders"
                sum=1
                :key="item.id"
            >
                <a class="guide-title">{{item.text}}</a>
                <a>
                    <img
                        class="act-banner"
                        :src="item.urls"
                        lazy="loaded"
                    >
                </a>
                <a
                    v-if="index==2"
                    class="slide-a"
                >
                    <p
                        class="slide-btn"
                        @click="goPage"
                    >开启优享免息</p>
                </a>
                <span style="position:absolute">
                    <span
                        v-if="index==0"
                        class="class-guide class-guide1"
                    ></span>
                    <span
                        v-if="index==1"
                        class="class-guide class-guide2"
                    ></span>
                    <span
                        v-if="index==2"
                        class="class-guide class-guide3"
                    ></span>
                    <span
                        v-if="index==2"
                        class="class-guide class-guide33"
                    ></span>
                </span>
            </p>
        </Slider>
    </div>
</template>

<script>
import Slider from '@/components/Slider.vue';
import { setJDJRNativeHeaderColor } from '@/util/jdjrNative';
import { shareInit } from '@/util/share';
import { genLinkBySSR } from '@/util/common';
import { messages } from '@/config';

export default {
    data() {
        return {
            ua: window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth > 320 ? true : false,
            sliders: [
                {
                    urls: this.ua
                        ? '//img11.360buyimg.com/cms/jfs/t26884/207/103603051/40482/9dca5637/5b84f99eN6bf41be5.png'
                        : '//img12.360buyimg.com/cms/jfs/t23836/193/2503545364/26117/34d0933a/5b84f99eN3c804430.png',
                    text: '左滑，不喜欢'
                },
                {
                    urls: this.ua
                        ? '//img11.360buyimg.com/cms/jfs/t26956/122/93188278/40792/ad9d838f/5b84fa9bN382c0cce.png'
                        : '//img10.360buyimg.com/cms/jfs/t24790/252/990168286/27179/c5e97b24/5b854128Nfe93fd19.png',
                    text: '右滑，加购物车'
                },
                {
                    urls: this.ua
                        ? '//img11.360buyimg.com/cms/jfs/t26872/180/93248281/35990/da2836ea/5b84fad3N2c948281.png'
                        : '//img20.360buyimg.com/cms/jfs/t26662/182/100432621/21093/360879bd/5b84fad3N434ea222.png',
                    text: '点击，查看详情'
                }
            ],
            dot: 'dot',
            showDots: true
        };
    },
    components: {
        Slider
    },
    mounted() {
        const defaultOption = {
            shareURL: genLinkBySSR('activity'),
            shareImgSrc: 'https://img12.360buyimg.com/jrpmobile/jfs/t28069/118/1531685442/19730/8e0317ae/5ce36be5Nf2ce9f2c.png',
            shareTitle: messages.shareTitle,
            shareDesc: messages.shareDesc,
            shareChannels: ['0', '1', '3']
        };
        shareInit(defaultOption);
        // 设置jdjr原生颜色
        setJDJRNativeHeaderColor('#000000');
        // console.log('this.$lazyload', this.$Lazyload.lazyLoadHandler());
    },
    methods: {
        goPage() {
            // try {
            //   if (!localStorage.guided) {
            //     localStorage.guided = false;
            //     localStorage.isShowGuide = false;
            //   }
            // } catch (error) {
            //   console.log(error);
            // }
            this.$emit('onFinish');
            // this.$router.push({ path: '/DiscoverPage' });
        }
    },
    destroyed() {
        this.$refs = null;
        this._self = null;
    }
};
</script>
<style lang="scss">
@import './../scss/mixin.scss';
.guide-bg {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 100;
    height: 100%;
    width: 100%;
    background: url('https://storage.jd.com/06-month/08/bg.png') no-repeat;
    background-size: 100% 100%;

    .guide-title {
        font-size: $rem40;
        padding: $rem80 0 $rem60 0;
        color: #ffffff;
        letter-spacing: 0;
        text-align: center;
    }
    .guide-swiper {
        height: 100%;
        padding-top: $rem64;
    }
    .act-banner {
        height: auto !important;
    }
    .act-htg440 {
        height: $rem440;
    }
    .act-slide {
        height: $rem440;
        overflow-y: hidden;
    }
    .slide-p {
        height: auto;
    }
    .slider-item {
        height: auto !important;
    }
    .slide-btn {
        background: #d2a35f;
        border-radius: $rem100;
        width: $rem570;
        height: $rem108;
        line-height: $rem108;
        font-size: $rem36;
        color: #ffffff;
        letter-spacing: 0;
        margin: 0 auto;
    }
    .slide-a {
        text-align: center;
        width: 100%;
        position: relative;
        top: -$rem120;
    }

    .dots {
        position: absolute;
        right: 0;
        left: 0;
        bottom: 12px;
        text-align: center;
        font-size: 0;
    }
    .dot {
        display: inline-block;
        margin: 0 4px;
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background: #fff;
    }
    .active {
        width: 20px;
        border-radius: 5px;
    }
    .addDot {
        background: red;
    }
    .class-guide {
        width: $rem100;
        height: $rem100;
        background-size: $rem100 $rem100;
        position: relative;
        display: inline-block;
        top: -$rem320;
        left: -$rem100;
    }
    .class-guide1 {
        background-image: url('https://storage.jd.com/06-month/08/left.png');
        animation: guideFirst1 2s infinite;
    }
    .class-guide2 {
        background-image: url('https://storage.jd.com/06-month/08/right.png');
        animation: guideFirst2 2s infinite;
    }
    .class-guide3 {
        background: url('https://storage.jd.com/06-month/08/circle.png') no-repeat;
        background-size: 100% 100%;
        animation: guideFirst3 1.5s 1.5s infinite;
        top: -$rem500;
        left: $rem100;
    }
    .class-guide33 {
        background-image: url('https://storage.jd.com/06-month/08/left.png');
        position: relative;
        display: inline-block;
        top: -$rem470;
        left: $rem30;
        animation: guideFirst4 1.5s infinite;
    }

    @media screen and (max-height: 480px) {
        .guide-title {
            font-size: $rem36;
            padding: $rem100 0 $rem30 0;
            color: #ffffff;
            letter-spacing: 0;
            text-align: center;
        }

        .guide-swiper {
            height: 100%;
            padding-top: 0;
        }

        .slide-btn {
            background: #d2a35f;
            border-radius: $rem100;
            width: $rem480;
            height: $rem88;
            line-height: $rem88;
            font-size: $rem32;
            color: #ffffff;
            letter-spacing: 0;
            margin: 0 auto;
        }
    }
}

@keyframes guideFirst1 {
    0% {
        transform: translate($rem100, 0);
    }
    100% {
        transform: translate(-$rem120, $rem120);
    }
}
@keyframes guideFirst2 {
    0% {
        transform: translate(-$rem0, 0);
    }
    100% {
        transform: translate($rem170, $rem120);
    }
}

@keyframes guideFirst3 {
    0% {
        width: $rem95;
        height: $rem95;
    }
    100% {
        width: $rem95;
        height: $rem95;

        transform: scale(1.4);
    }
}
@keyframes guideFirst4 {
    0% {
        transform: translate(30px, 30px);
    }
    100% {
        transform: translate(0px, 0px);
    }
}
// iphoneX适配
@media only screen and (device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3) and (orientation: portrait) {
    .guide-bg > .slider > .ui-dots {
        bottom: 46px;
    }
}
</style>
